import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { BrowserRouter } from 'react-router-dom';
import Root from './Root';
import { TooltipProvider } from '@/components/ui/tooltip';
import './index.css';

const CLERK_PK = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string;
if (!CLERK_PK) throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY');

// The sign-in card is the largest thing on a signed-out screen and it comes from Clerk's own host,
// which is encoded in the publishable key ("pk_test_" + base64("<host>$")). Opening that connection
// now, before React and Clerk's script load, takes the DNS and TLS handshakes off the card's paint.
try {
  const host = atob(CLERK_PK.replace(/^pk_(test|live)_/, '')).replace(/\$$/, '');
  if (/^[a-z0-9.-]+$/i.test(host)) {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = `https://${host}`;
    link.crossOrigin = '';
    document.head.appendChild(link);
  }
} catch { /* an unexpected key format only costs the head start */ }

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={CLERK_PK}>
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </ClerkProvider>
  </React.StrictMode>,
);
